export default "__VITE_ASSET__7182d78b__"